import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-payment',
  standalone: false,
  templateUrl: './error-payment.component.html',
  styleUrl: './error-payment.component.scss'
})
export class ErrorPaymentComponent {

  constructor(private router: Router) { 
  }

  retryPayment() {
    this.router.navigate(['funnel/overview']);
  }
}
